import { useCallback, useEffect } from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { ExpiresOn } from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';
import { IMealCreditFormFields } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';

export interface UseSetExpiresOnSelectProps {
  isActive: boolean;
}

export const useSetExpiresOnSelect = ({
  isActive,
}: UseSetExpiresOnSelectProps): void => {
  const { getValues, setValue, formState } =
    useFormContext<IMealCreditFormFields>();
  const {
    dirtyFields: { expiresOn: isExpiresOnDirty },
  } = formState;

  const setExpiresOnSelect = useCallback((): void => {
    const expiration = getValues('expiration');
    const expiresOn = getValues('expiresOn');

    if (!expiration && expiresOn === ExpiresOn.ON_THIS_DAY) {
      setValue('expiresOn', ExpiresOn.NEVER);
    }
  }, [getValues, setValue]);

  useEffect(() => {
    if (!isActive && isExpiresOnDirty) {
      setExpiresOnSelect();
    }
  }, [isActive, isExpiresOnDirty, setExpiresOnSelect]);
};
